
import './App.css';
import FilterBar from './Components/FilterBar'
import Map from './Map.js';
import allData from './Building_People.json'
import { useState } from 'react'


function App() {

  const [selectedRegion, setSelectedRegion] = useState('')

  const generateTargetAudienceData = () => {
    return  [...new Set([].concat.apply([], ([...new Set(allData.features.map((item) => item.properties["Target group"]))])))].sort().filter(n => n);
  };

  const generateAgeGroupData = () => {
    return  [...new Set([].concat.apply([], ([...new Set(allData.features.map((item) => item.properties["Age groups"]))])))].sort().filter(n => n);
  };

  const generateActivitiesData = () => {
    return  [...new Set([].concat.apply([], ([...new Set(allData.features.map((item) => item.properties["Activities"]))])))].sort().filter(n => n);
  };

  // const generateProfessionsData = () => {
  //   return  [...new Set([].concat.apply([], ([...new Set(allData.features.map((item) => item.properties["Professions"]))])))].sort().filter(n => n);
  // };

  // const generateTradesData = () => {
  //   return  [...new Set([].concat.apply([], ([...new Set(allData.features.map((item) => item.properties["Trades"]))])))].sort().filter(n => n);
  // };


  return (
    
 <div>

  < Map 
    selectedRegion={selectedRegion} 
    setSelectedRegion={setSelectedRegion}
  />

  <FilterBar 
    selectedRegion={selectedRegion}
    allData={allData.features}
    targetAudience={generateTargetAudienceData()} 
    ageGroups={generateAgeGroupData()} 
    activities={generateActivitiesData()} 
    // professions={generateProfessionsData()} 
    // trades={generateTradesData()}
  />

   </div>

  );
}

export default App;
